

// src/slices/serviceSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://payyug.in/api";

// === Fetch All Services (GET with superadminId & serviceTypeId) ===
export const fetchAllServices = createAsyncThunk(
  "service/fetchAllServices",
  async (filters = {}, { rejectWithValue }) => {
    try {
      // ✅ Get IDs (from filters or localStorage)
      const superadminId =
        filters.superadminId || localStorage.getItem("adminuserId");
      const serviceTypeId = filters.serviceTypeId;

      if (!superadminId || !serviceTypeId) {
        throw new Error("superadminId and serviceTypeId are required");
      }

      // ✅ API call
      const response = await axios.get(
        `${BASE_URL}/all-service-new?superadminId=${superadminId}&serviceTypeId=${serviceTypeId}`
      );
      console.log("API Responseddd:", response.data); // 👈 Check here

      return response.data; // { success, data: [...] }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

const serviceSlice = createSlice({
  name: "serviceloan",
  initialState: {
    allServices: [],
    loadingService: false,
    errorservice: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllServices.pending, (state) => {
        state.loadingService = true;
        state.errorservice = null;
      })
      .addCase(fetchAllServices.fulfilled, (state, action) => {
  state.loadingService = false;
  state.allServices = action.payload?.data || [];  // ✅ Save services here
  state.errorservice = null;                       // ✅ Reset error
})
      .addCase(fetchAllServices.rejected, (state, action) => {
        state.loadingService = false;
        state.errorservice = action.payload;
      });
  },
});

export default serviceSlice.reducer;
